import { h } from '@stencil/core';
import { BUTTON_TYPES, ICONS_BY_TYPE, LINK_TYPES, RangeCTAPosition, scrollBehavior, TARGET_BY_TYPE, CheckoutEventEmitter, exitToSchneiderEvent, scrollToComponent, send } from '@pes-ui/utils';
import { isEmpty } from 'lodash';
import { getCtaInfoMapping, getLocaleCodes } from '../../../globals/utils/helpers';
import { addPDPCTAClickGAEvent } from '../utils';
import { SDL_FOOTER_SEEMAIL } from '../constants';
export class PesCtasRow {
  constructor() {
    this.newsletterClick = () => {
      const el = document.querySelector(`#${SDL_FOOTER_SEEMAIL}`);
      if (!el)
        return null;
      scrollToComponent(el, { behavior: scrollBehavior.SMOOTH });
      el.focus();
    };
    this.handleLinksClick = (cta, data) => (event) => {
      var _a, _b, _c, _d, _e, _f, _g;
      switch (cta) {
        case LINK_TYPES.REGISTER_TO_NEWSLETTER:
          this.newsletterClick();
          break;
        case LINK_TYPES.FIND_RESELLER:
        case LINK_TYPES.CONTACT_SALES:
        case LINK_TYPES.CONTACT_SUPPORT:
          addPDPCTAClickGAEvent({
            name: (_b = (_a = data === null || data === void 0 ? void 0 : data[cta]) === null || _a === void 0 ? void 0 : _a.gaAttributes.name) !== null && _b !== void 0 ? _b : '',
            category: (_d = (_c = data === null || data === void 0 ? void 0 : data[cta]) === null || _c === void 0 ? void 0 : _c.gaAttributes.category) !== null && _d !== void 0 ? _d : '',
            url: (_e = data === null || data === void 0 ? void 0 : data[cta]) === null || _e === void 0 ? void 0 : _e.url,
            position: RangeCTAPosition.SUBDUED,
          });
          break;
        case LINK_TYPES.BUY_ONLINE:
        case LINK_TYPES.BUY_MARKETPLACE:
          send(exitToSchneiderEvent, { link_url: (_f = data === null || data === void 0 ? void 0 : data[cta]) === null || _f === void 0 ? void 0 : _f.url });
          this.buyOnlineClick.emit((_g = data === null || data === void 0 ? void 0 : data[cta]) === null || _g === void 0 ? void 0 : _g.url);
          event.preventDefault();
          break;
        case BUTTON_TYPES.ADD_TO_MYLIST:
          CheckoutEventEmitter.dispatchCheckoutEvent(cta, this.checkoutEasyPayload);
          break;
        default:
          break;
      }
    };
    this.ctaInfo = undefined;
    this.showBuyOnline = undefined;
    this.productId = undefined;
    this.localeCode = undefined;
    this.ctaInfoMapping = {};
    this.showCtas = false;
    this.itemCtas = undefined;
    this.checkoutEasyPayload = null;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillRender() {
    this.updateCheckoutPayload();
  }
  componentWillLoad() {
    this.showCtas = !isEmpty(this.ctaInfo);
    if (!this.showCtas)
      return;
    this.itemCtas = Object.keys(this.ctaInfo);
    this.ctaInfoMapping = getCtaInfoMapping(this.itemCtas, this.ctaInfo);
  }
  updateCheckoutPayload() {
    if (!this.localeCode)
      return;
    const countryLocaleData = getLocaleCodes(this.localeCode);
    if (!(countryLocaleData === null || countryLocaleData === void 0 ? void 0 : countryLocaleData.countryCode) || !(countryLocaleData === null || countryLocaleData === void 0 ? void 0 : countryLocaleData.languageCode))
      return;
    const country = countryLocaleData.countryCode.toUpperCase();
    const locale = `${countryLocaleData.languageCode}_${country}`;
    const checkoutPayload = {
      country,
      locale,
      productId: this.productId,
    };
    if (!this.checkoutEasyPayload
      || this.checkoutEasyPayload.country !== checkoutPayload.country
      || this.checkoutEasyPayload.locale !== checkoutPayload.locale
      || this.checkoutEasyPayload.productId !== checkoutPayload.productId) {
      this.checkoutEasyPayload = checkoutPayload;
    }
  }
  render() {
    var _a, _b;
    return (h("div", { class: "cta_links" }, this.showCtas && ((_b = (_a = this.itemCtas) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, (cta) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      const shouldRenderCta = cta !== LINK_TYPES.BUY_ONLINE || this.showBuyOnline;
      if (!shouldRenderCta)
        return null;
      return (h("div", { class: "cta_links__item", key: cta }, h("pes-cta-button", { class: "cta-area__button", icon: (_a = ICONS_BY_TYPE[cta]) !== null && _a !== void 0 ? _a : null, text: (_d = (_c = (_b = this.ctaInfo) === null || _b === void 0 ? void 0 : _b[cta]) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : null, url: (_g = (_f = (_e = this.ctaInfo) === null || _e === void 0 ? void 0 : _e[cta]) === null || _f === void 0 ? void 0 : _f.url) !== null && _g !== void 0 ? _g : null, importance: (_h = this.ctaInfoMapping[cta]) === null || _h === void 0 ? void 0 : _h.importance, size: (_j = this.ctaInfoMapping[cta]) === null || _j === void 0 ? void 0 : _j.size, target: TARGET_BY_TYPE[cta], anchor: cta === LINK_TYPES.REGISTER_TO_NEWSLETTER ? SDL_FOOTER_SEEMAIL : null, onClick: this.handleLinksClick(cta, this.ctaInfo).bind(this) })));
    }))));
  }
  static get is() { return "pes-ctas-row"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-ctas-row.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-ctas-row.css"]
    };
  }
  static get properties() {
    return {
      "ctaInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsApi.TCtaInfo",
          "resolved": "{ [key: string]: { type: string; label?: string; primary?: boolean; url?: string; gaAttributes?: TGaAttributes; }; }",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Links data"
        }
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Buy online"
        },
        "attribute": "show-buy-online",
        "reflect": false
      },
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "ctaInfoMapping": {},
      "showCtas": {},
      "itemCtas": {},
      "checkoutEasyPayload": {}
    };
  }
  static get events() {
    return [{
        "method": "buyOnlineClick",
        "name": "buyOnlineClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string | undefined",
          "resolved": "string",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
}
